import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=107192e5&scoped=true&"
import script from "./bindWechat.vue?vue&type=script&lang=js&"
export * from "./bindWechat.vue?vue&type=script&lang=js&"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=107192e5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107192e5",
  null
  
)

export default component.exports